import { render, staticRenderFns } from "./IdentifierDisplay.vue?vue&type=template&id=05b00cb1"
import script from "./IdentifierDisplay.vue?vue&type=script&lang=js"
export * from "./IdentifierDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports